<template>
    <header class="header-authorization">
      <div class="container-fluid">
        <div class="row justify-content-between align-items-center">
          <div class="col-auto"><router-link class="svg-icon header-authorization__logo" to="/" aria-label="TTC">
              <svg class="logo logo_full" role="img" width="109" height="58" aria-hidden="true">
                <use xlink:href="#svg-logo"></use>
              </svg>
              <svg class="logo logo_short" role="img" width="63" height="24" aria-hidden="true">
                <use xlink:href="#svg-logo-mobile"></use>
              </svg></router-link></div>
          <div class="col-auto">
            <div class="localization">
              <select class="btn localization__btn" v-model="locale" @change="setLocale" name="" id="">
                <option value="ru">Рус</option>
                <option value="kz">Қаз</option>
                <option value="en">En</option>
              </select>
              <!-- <button class="btn localization__btn js-toggle-localization" type="button" aria-label="Выбрать язык"><span class="btn__text">Рус</span><span class="btn__icon svg-icon" aria-hidden="true">
                  <svg role="img" width="14" height="14" aria-hidden="true">
                    <use xlink:href="#svg-icon-arrow-next"></use>
                  </svg></span></button>
              <ul class="list list_unstyled localization__list">
                <li class="list__item"><a class="link localization__link active" href="javascript: void(0);">Рус</a></li>
                <li class="list__item"><a class="link localization__link" href="javascript: void(0);">Kz</a></li>
                <li class="list__item"><a class="link localization__link" href="javascript: void(0);">En</a></li>
              </ul> -->
            </div>
          </div>
        </div>
      </div>
    </header>
</template>
<script>
import {mapMutations} from 'vuex';
export default {
  data(){
    return {
      locale: localStorage.getItem('locale') || 'ru',
    }
  },
  methods: {
    ...mapMutations({
      setLanguage: 'assistant/setLanguage'
    }),
    setLocale() {
      localStorage.setItem('locale', this.locale) 
      this.$i18n.locale = this.locale
      this.setLanguage(this.locale)
      if(this.locale === 'ru'){
        document.title = "TTC Личный кабинет"
      }else if(this.locale === 'kz'){
        document.title = "TTC Жеке кабинет"
      }else{
        document.title = "TTC Personal area"
      }
    }
  },
  created() {
    this.setLocale()
  }
}
</script>
<style scoped>
  .localization__btn{
    background-color: #808080;  
    border: none;
    min-height: 25px;
  }
  .localization__btn option{
    width: 200px;
  }
</style>